import React from "react";
import { Navigation, Link } from "react-router";
import { Grid, Row, Col, Glyphicon} from "react-bootstrap";
import FontAwesome from "react-fontawesome";
import Api from "js/utilities/fnapi-client"
import { sidebarOnClicks, mountCode, initDeepLinkData, urlChangeHandler } from "js/utilities/sdk-doc-utils";
import UserHandler from "js/utilities/user-handler";
import SDKSidebar from "js/utilities/sdk-sidebar"
import ApptokenDisplay from "js/utilities/get-display-apptoken";
import AppnameDisplay from "js/utilities/get-display-appname";
import Loader from "react-loader";
import Zoom from "js/utilities/zoom-handler"
import Amplitude from "js/utilities/amplitude";
import { ZOOM_ICON } from "js/config.jsx";

import ZOOM_SHORT_LOGO from "resources/img/zoom_logo_dark.png";
import CORDOVA_LOGO from "resources/img/cordova.png";
import APPCELERATOR_LOGO from "resources/img/appcelerator.png";
import XAMARIN_LOGO from "resources/img/xamarin.png";
import REACT_LOGO from "resources/img/react_native.png";
import IONIC_LOGO from "resources/img/ionic.png";
import PHONEGAP_LOGO from "resources/img/phonegap.png";
import GITHUB_LOGO from "resources/img/GitHub-Mark-120px-plus.png";
import JS_LOGO from "resources/img/js.png";
import NODE_JS_LOGO from "resources/img/node_js.png";


export default React.createClass({
  mixins: [Navigation],

  displayName: "plugins",

  contextTypes: {
    router: React.PropTypes.object.isRequired
  },

  getInitialState() {
    var scrollToElement = initDeepLinkData(this.props);
    return {
      error: "",
      scrollToElement: scrollToElement
    };
  },

  componentDidMount: function() {
    sidebarOnClicks();
    mountCode(this);
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function() {
    return (
      <div className="dash">
        <div className="workspace">
          <div className="workspace__container">
            <section>
              <div className="title">
                <Glyphicon glyph="download" />
                <h2 id="3rd-party-framework-sample-code">3rd Party Framework Sample Code</h2>
              </div>
              <p>The below links to Github repositories contain sample plugins and code for running FaceTec using different frameworks.</p>
              <hr/>
            </section>
            <section>
              <blockquote>
                <p><strong>Important</strong>: The below sample code are <strong>not supported by FaceTec</strong>, and we will be unfortunately unable to respond to any inquiries about them.</p>
                <p>If you are familiar with Appcelerator, Xamarin, React Native, Cordova, Ionic, Phonegap, and Node, these samples should demonstrate the majority of the work needed to get FaceTec functional in your application with these frameworks.</p>
              </blockquote>
              <h4 id="framework-plugin-libraries">Framework/Plugin Libraries</h4>

              <div className="panel-holder">
                <a href="https://github.com/facetec/titanium-module-zoom" target="_blank" className="panel-button">
                  <img style={{height: "50px"}} src={APPCELERATOR_LOGO}/>
                  <div style={{width: "100%"}}>
                    <h5 className="big">FaceTec SDKs Appcelerator</h5>
                  </div>
                </a>
                <a href="https://github.com/facetec/cordova-plugin-zoom-sdk" target="_blank" className="panel-button">
                  <img style={{height: "50px"}} src={CORDOVA_LOGO}/>
                  <div style={{width: "100%"}}>
                    <h5 className="big">FaceTec SDKs Cordova</h5>
                  </div>
                </a>
              </div>

              <div className="panel-holder">
                <a href="https://github.com/facetec/cordova-plugin-zoom-sdk" target="_blank" className="panel-button">
                  <img style={{height: "50px"}} src={PHONEGAP_LOGO}/>
                  <div style={{width: "100%"}}>
                    <h5 className="big">FaceTec SDKs Appcelerator</h5>
                  </div>
                </a>
                <a href="https://github.com/facetec/cordova-plugin-zoom-sdk" target="_blank" className="panel-button">
                  <img style={{height: "50px"}} src={IONIC_LOGO}/>
                  <div style={{width: "100%"}}>
                    <h5 className="big">FaceTec SDKs Ionic</h5>
                  </div>
                </a>
              </div>

              <div className="panel-holder">
                <a href="https://github.com/facetec/xamarin-zoom" target="_blank" className="panel-button">
                  <img style={{height: "50px"}} src={XAMARIN_LOGO}/>
                  <div style={{width: "100%"}}>
                    <h5 className="big">FaceTec SDKs Xamarin</h5>
                  </div>
                </a>
                <a href="https://github.com/tradle/react-native-facetec-zoom" target="_blank" className="panel-button">
                  <img style={{height: "50px"}} src={REACT_LOGO}/>
                  <div style={{width: "100%"}}>
                    <h5 className="big">FaceTec SDKs React Native</h5>
                  </div>
                </a>
              </div>
            </section>

            <SDKSidebar menuType="main" title="Plugins"/>
          </div>
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/plugins.jsx